import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { useEffect } from 'react';
import { useAlert } from '@rahtab/ui/dist/components/Alert';
import { useNavigation } from '@react-navigation/core';

const useStartRevision = (assignFinalCode: string) => {
  const { goBack } = useNavigation();
  const alert = useAlert();
  const [startRevision, { loading, data, called }] = useFetchCallType<StartRevisionResult>('StartCorrectionRemaining', {
    params: `AssignFinallCode=${assignFinalCode}`,
    skip: true,
  });
  useEffect(() => {
    if (data && !loading) {
      const { error, result: success } = data;
      if (!success)
        alert({
          title: 'پیام سیستم',
          message: error,
          severity: 'error',
          hideBackButton: true,
          notClosableByOutsidePress: true,
          buttons: [
            {
              text: 'بازگشت',
              variant: 'outlined',
              color: 'secondary',
              onPress: () => goBack(),
            },
          ],
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.result, loading]);
  console.log('revisionResult', loading, data);
  return { startRevision, loading, data, called };
};

export default useStartRevision;
interface StartRevisionResult {
  result: boolean;
  message: string;
  error: string;
  wfInstanceCode: string;
  dtc: string;
  formCode: string;
  compileDC: string;
  wfName: string;
  remainingValue: string;
  stateCode: string;
}
